import { render, staticRenderFns } from "./ChannelWrapper.vue?vue&type=template&id=51a56434&"
import script from "./ChannelWrapper.vue?vue&type=script&lang=js&"
export * from "./ChannelWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports